import React from 'react';

const standardField = (props) => {

	let field = null;

	if(props.f.kind === 'text' || props.f.kind === 'password' || props.f.kind === 'email') {
		field = <input className='text-input' type={props.f.kind} name={props.id} placeholder={props.f.name} value={props.f.value} onChange={props.handler} onKeyPress={props.kbhandler} />
	}
	else if(props.f.kind === 'select' && props.f.options.length) {

		let options = Object.keys(props.f.options)
			.map(o => {
				const opt = props.f.options[o];
				return <option key={o} disabled={+o === 0 ? true : null} value={opt}>{opt}</option>
			});

		let classes = 'select__enh';
		if(props.f.value === props.f.options[0]) classes += ' select__enh--option-disabled';

		field = (
			<label className='select'>
				<select className='select__std' name={props.id} value={props.f.value} onChange={props.handler}>{options}</select>
				<span className={classes}>{props.f.value} <span className='select__enh__btn'><i className='fas fa-angle-down'></i></span></span>
			</label>
		);
	}
	else if(props.f.kind === 'check') {
		let classes = 'checkbox__enh';
		if(props.f.value) classes += ' checkbox__enh--checked';
		field = (
			<label className='checkbox'>
				<input className='checkbox__std' checked={props.f.value} value="yes" onChange={props.handler} name={props.id} type='checkbox' />
				<span className={classes}><i className='fas fa-check'></i></span> <span className='checkbox__text'>{props.f.name}</span>
			</label>
		);
	}

	return field;

}

export default standardField;


// WEBPACK FOOTER //
// ./src/UI/StandardField.js